
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/tools.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-intermediate-tools-demo-tools-basic","docs-tutorial-intermediate-tools-demo-tools-onhover"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/tools.zh.md?type=demo')
};